import React from "react";

import { Call, Position, useCallClipsQuery } from "../../../graphql";
import ClipsTabBase from "../../Recording/SidebarTabs/ClipsTab";

export type ClipsTabProps = {
  call: Pick<Call, "id" | "canEdit" | "canShare" | "canShareExternal"> & {
    position?: Pick<Position, "id"> | null;
  };
  onCreateClipClick?(): void;
};

const ClipsTab: React.FC<ClipsTabProps> = ({ call, onCreateClipClick }) => {
  const { data, loading, error } = useCallClipsQuery({
    variables: { callId: call.id },
  });
  const clips = data?.call?.callClips ?? [];

  return (
    <ClipsTabBase
      clips={clips}
      callId={call.id}
      positionId={call.position?.id}
      readOnly={!call.canEdit}
      onCreateClipClick={onCreateClipClick}
      canShare={call.canShare || call.canShareExternal}
      loading={loading}
      error={error?.message}
    />
  );
};

export default ClipsTab;
